import { render } from "./PatientAccountabilityHeader.vue?vue&type=template&id=86ab3d84&scoped=true"
import script from "./PatientAccountabilityHeader.vue?vue&type=script&lang=js"
export * from "./PatientAccountabilityHeader.vue?vue&type=script&lang=js"

import "./PatientAccountabilityHeader.vue?vue&type=style&index=0&id=86ab3d84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ab3d84"]])

export default __exports__